import React, { useEffect, useRef } from "react";
import { DASHBOARDS_CONSTANTS } from "src/constants/dashboardConstants";
import { dashboardLocales } from "src/locales/dashboardLocales";
import { PaginationProps } from "src/models/dashboard.models";

import { CFormSelect, CPagination, CPaginationItem } from "@coreui/react";

const CustomPagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  onPageSizeChange,
}) => {
  const paginationRef = useRef<HTMLDivElement>(null);
  const activeItemRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (activeItemRef.current && paginationRef.current) {
      activeItemRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [currentPage]);

  return (
    <div className="d-flex justify-content-between mt-3">
      <div>
        <CFormSelect
          onChange={e => onPageSizeChange(+e.target.value)}
          className="dd-pagination-select-box"
        >
          <option value="10">{DASHBOARDS_CONSTANTS.PAGE_SIZE.TEN}</option>
          <option value="20">{DASHBOARDS_CONSTANTS.PAGE_SIZE.TWENTY}</option>
          <option value="50">{DASHBOARDS_CONSTANTS.PAGE_SIZE.FIFTY}</option>
          <option value="100">{DASHBOARDS_CONSTANTS.PAGE_SIZE.HUNDRED}</option>
        </CFormSelect>
      </div>
      <div className="dd-pagination-container" ref={paginationRef}>
        <CPagination className="dd-pagination">
          <CPaginationItem
            disabled={currentPage === DASHBOARDS_CONSTANTS.CURRENT_PAGE}
            onClick={() =>
              onPageChange(currentPage - DASHBOARDS_CONSTANTS.CURRENT_PAGE)
            }
          >
            {dashboardLocales.previous}
          </CPaginationItem>
          {Array.from({ length: totalPages }, (_, i) => (
            <CPaginationItem
              key={i + 1}
              ref={
                currentPage === i + DASHBOARDS_CONSTANTS.CURRENT_PAGE
                  ? activeItemRef
                  : null
              }
              active={currentPage === i + DASHBOARDS_CONSTANTS.CURRENT_PAGE}
              onClick={() =>
                onPageChange(i + DASHBOARDS_CONSTANTS.CURRENT_PAGE)
              }
            >
              {i + DASHBOARDS_CONSTANTS.CURRENT_PAGE}
            </CPaginationItem>
          ))}
          <CPaginationItem
            disabled={currentPage === totalPages}
            onClick={() =>
              onPageChange(currentPage + DASHBOARDS_CONSTANTS.CURRENT_PAGE)
            }
          >
            {dashboardLocales.next}
          </CPaginationItem>
        </CPagination>
      </div>
    </div>
  );
};

export default CustomPagination;
